import {PartialUserProfile} from '@app/web-player/users/user-profile';
import {StarIcon} from '@ui/icons/material/Star';
import {VerifiedIcon} from '@ui/icons/material/Verified';
import clsx from 'clsx';

interface UserBadgesProps {
  user: {
    is_pro?: boolean;
    is_verified?: boolean;
    sngine_badges?: PartialUserProfile['sngine_badges'];
  };
  className?: string;
  size?: 'sm' | 'md';
}

export function UserBadges({user, className, size = 'md'}: UserBadgesProps) {
  const isVerified = user.sngine_badges?.verified ?? user.is_verified ?? false;
  const isPro = user.sngine_badges?.pro ?? user.is_pro ?? false;
  const siteBadges = user.sngine_badges?.site ?? [];

  if (!isVerified && !isPro && !siteBadges.length) {
    return null;
  }

  const iconSize = size === 'sm' ? 'text-base' : 'text-xl';

  return (
    <span
      className={clsx('inline-flex shrink-0 items-center gap-1', className)}
    >
      {isVerified && (
        <VerifiedIcon
          className="text-primary"
          size={iconSize}
          title="Verified"
        />
      )}
      {isPro && (
        <span
          className="inline-flex rounded-full bg-amber-500 p-0.5 text-white"
          title="Pro"
        >
          <StarIcon size={size === 'sm' ? 'xs' : 'sm'} />
        </span>
      )}
      {siteBadges.map(badge =>
        size === 'sm' ? (
          <span
            key={badge.key}
            className="h-2.5 w-2.5 rounded-full"
            style={{backgroundColor: badge.color || '#64748b'}}
            title={`${badge.name}${badge.description ? ` - ${badge.description}` : ''}`}
          />
        ) : (
          <span
            key={badge.key}
            className="inline-flex max-w-[160px] items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold text-white"
            style={{backgroundColor: badge.color || '#64748b'}}
            title={`${badge.name}${badge.description ? ` - ${badge.description}` : ''}`}
          >
            {badge.icon_class && <i className={badge.icon_class} />}
            <span className="min-w-0 truncate">{badge.name}</span>
          </span>
        ),
      )}
    </span>
  );
}
